/* Rounds up to the nearest ten */
const roundUp = (price: number): number => {
  return Math.ceil(price);
};

export const formatPrice = (
  price: number,
  addCommissions: boolean,
  locale: string = "it-IT",
  currency: string = "EUR",
): string => {
  if (addCommissions) {
    // Standard practice: 30% commission + 22% VAT on commission
    // Multiplier: 1 + 0.30 + (0.30 * 0.22) = 1.366
    price *= 1.366;
    price = roundUp(price);
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(price || 0);
};

export const calculatePriceString = (
  price: number,
  addCommissions: boolean,
): string => {
  if (addCommissions) {
    // Standard practice: 30% commission + 22% VAT on commission
    price *= 1.366;
    price = roundUp(price);
  }
  return price.toFixed(2);
};

export const calculatePriceNumeric = (
  price: number,
  addCommissions: boolean,
): number => {
  if (addCommissions) {
    // Standard practice: 30% commission + 22% VAT on commission
    price *= 1.366;
    price = roundUp(price);
  }
  return price;
};
